import React from "react";
import {
  Box,
  Button,
  Group,
  Modal,
  SimpleGrid,
  Text,
  TextInput,
  createStyles,
} from "@mantine/core";

import { useForm } from "@mantine/form";
import { useSelector } from "react-redux";
import { createFolder, updateFolder } from "../../services/Document";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },

  camera: {
    position: "absolute",
    // position:'relative',
    // top:'28%',
    // right:'5%',
    marginTop: 75,
    marginLeft: 75,
    background: "#FFBA45",
    borderRadius: "50%",
    padding: 5,
    [`&:hover`]: {
      cursor: "pointer",
    },
  },
  drop: {
    display: "none",
    "& .mantine-Image-image": {
      border: "2px solid green",
    },
  },
  dropImage: {
    img: {
      borderRadius: "50%",
    },
  },
  myfont: {
    fontFamily: "Inter",
    // marginTop: 20,
    overflow: "visible",
  },
  mycommmentfont: {
    fontFamily: "Inter",
    fontSize: "none !important",
    // marginTop: 20,
    overflow: "visible",
    "& .mantine-Textarea-label": {
      fontSize: "1rem !important",
    },
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    "& .mantine-Modal-body": {
      backgroundColor: "#F5F5F5",
    },
  },
  mwd: {
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: 10,
    padding: 20,
    marginBottom: 20,
    border: "1px solid #E5E5EA",
  },
}));

const CreateFolderModal = ({
  opened,
  onclose,
  title,
  data,
  client,
  selectedFolder,
}) => {
  const { classes } = useStyles();
  const { createFolderLoading } = useSelector((state) => state.document);

  const form = useForm({
    initialValues: {
      name: data?.name || "",
    },
    validate: {
      name: (value) => (value ? null : "Please specify Folder Name"),
    },
  });
  const resetForm = () => {
    form?.reset();
    onclose();
  };

  const onSave = async (values) => {
    try {
      if (data) {
        let payload = {
          ...values,
          folder: data?._id,
          client,
        };
        await updateFolder(payload, client, "client");
      } else {
        let payload = {
          ...values,
          client,
          folderId: selectedFolder?._id,
        };
        await createFolder(payload, client, "client");
      }
      onclose();
      resetForm();
    } catch (error) {
      console.error("Error creating folder:", error.message);
    }
  };

  return (
    <>
      <Modal
        className={classes.mymodal}
        opened={opened}
        size={"lg"}
        onClose={() => {
          onclose();
        }}
        shadow="md"
        overlayProps={{ blur: 3 }}
        radius={"lg"}
        zIndex={1000}
        title={
          <Box>
            <Text sx={{ fontFamily: "Inter", fontSize: 22, fontWeight: 600 }}>
              {title}
            </Text>
          </Box>
        }
        centered
      >
        <form onSubmit={form?.onSubmit((values) => onSave(values))}>
          <SimpleGrid cols={1} className={classes.mwd}>
            <TextInput
              className={classes.myfont}
              value={form?.values?.name}
              label="Name"
              size="md"
              //   icon={<img src="/assets/images/profile.png" alt="home" />}
              placeholder="Folder Name"
              //onChange={(event) => setForm({ ...form, values: { ...form?.values, name: event.target.value } })}
              {...form.getInputProps("name")}
              //disabled={view}
            />
          </SimpleGrid>

          <Group mt={20} grow>
            <Button
              color="gray"
              variant="outline"
              c={"#000"}
              fullWidth
              sx={{ fontFamily: "Inter" }}
              onClick={onclose}
            >
              Cancel
            </Button>
            <Button
              fullWidth
              c={"#000"}
              color="yellow"
              sx={{ fontFamily: "Inter" }}
              type="submit"
              loading={createFolderLoading}
            >
              {data ? "Update" : "Create"}
            </Button>
          </Group>
        </form>
      </Modal>
    </>
  );
};

export default CreateFolderModal;
